import { render, staticRenderFns } from "./noticePopover.vue?vue&type=template&id=56057bcb&scoped=true"
import script from "./noticePopover.vue?vue&type=script&lang=js"
export * from "./noticePopover.vue?vue&type=script&lang=js"
import style0 from "./noticePopover.vue?vue&type=style&index=0&id=56057bcb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56057bcb",
  null
  
)

export default component.exports